// Written by `pnpm build:cliffs`: every cliff window the zones hold, in the order of the cliff sheets.
export const CLIFF_WINDOWS = [
    '0000000000000000',
    '0000000000110011',
    '0000000000110012',
    '0000000000110111',
    '0000000000111111',
    '0000000001110111',
    '0000000001110122',
    '0000000001111111',
    '0000000011001100',
    '0000000011001110',
    '0000000011001111',
    '0000000011002110',
    '0000000011002111',
    '0000000011101110',
    '0000000011101111',
    '0000000011102111',
    '0000000011102211',
    '0000000011111111',
    '0000000011111222',
    '0000000011112111',
    '0000000011112211',
    '0000000011112221',
    '0000000011112222',
    '0000000100110011',
    '0000000100110111',
    '0000000100110112',
    '0000000100111111',
    '0000000100111112',
    '0000000101110111',
    '0000000101110112',
    '0000000101111111',
    '0000000111111111',
    '0000000111112222',
    '0000001100110001',
    '0000001100110011',
    '0000001100110111',
    '0000001100120012',
    '0000001101110111',
    '0000001101111111',
    '0000001101111112',
    '0000001101111122',
    '0000001111111111',
    '0000001111111112',
    '0000001111112222',
    '0000011101220122',
    '0000100011001100',
    '0000100011001110',
    '0000100011001111',
    '0000100011002100',
    '0000100011002110',
    '0000100011101110',
    '0000100011101111',
    '0000100011102111',
    '0000100011102211',
    '0000100011111111',
    '0000100011112211',
    '0000100011112222',
    '0000110011001100',
    '0000110011001110',
    '0000110011001111',
    '0000110011002110',
    '0000110011101110',
    '0000110011101111',
    '0000110011102111',
    '0000110011102211',
    '0000110011111111',
    '0000110011112211',
    '0000110011112221',
    '0000110011112222',
    '0000110021102210',
    '0000110021112211',
    '0000110111111111',
    '0000111022112221',
    '0000111112221222',
    '0000111122112222',
    '0000111122212222',
    '0000111122222222',
    '0001000011111111',
    '0001000100110011',
    '0001000100110012',
    '0001000100110111',
    '0001000100111111',
    '0001000100111112',
    '0001000101110111',
    '0001000101111111',
    '0001000110111111',
    '0001000111111111',
    '0001000111112222',
    '0001001100110011',
    '0001001100110111',
    '0001001100111011',
    '0001001100120012',
    '0001001101110111',
    '0001001101111111',
    '0001001101111112',
    '0001001101121122',
    '0001001111111111',
    '0001001111111112',
    '0001001111121112',
    '0001001111121122',
    '0001100111011101',
    '0001101111111111',
    '0001111122222222',
    '0011000000000000',
    '0011000000000011',
    '0011000011111111',
    '0011000100000000',
    '0011000100010000',
    '0011000100010001',
    '0011000100010011',
    '0011001100000000',
    '0011001100001111',
    '0011001100010000',
    '0011001100010001',
    '0011001100110000',
    '0011001100110001',
    '0011001100110011',
    '0011001100110012',
    '0011001100110111',
    '0011001100110112',
    '0011001100111111',
    '0011001100120012',
    '0011001101110111',
    '0011001101110112',
    '0011001101111111',
    '0011001101121122',
    '0011001110111011',
    '0011001111111111',
    '0011001111112222',
    '0011001200120012',
    '0011001200120112',
    '0011011111221222',
    '0011011211221122',
    '0011011211221222',
    '0011101110111111',
    '0011111122222222',
    '0011111211221122',
    '0012001100010000',
    '0012001100010001',
    '0012001200120012',
    '0012001200120112',
    '0012001200121112',
    '0012001201120112',
    '0012001201120122',
    '0012001201121112',
    '0012001211121112',
    '0012011201220122',
    '0110000000000000',
    '0111000000000000',
    '0111000000000111',
    '0111000011101110',
    '0111000100000000',
    '0111000100010000',
    '0111000100010001',
    '0111001100000000',
    '0111001100010000',
    '0111001100010001',
    '0111001100110000',
    '0111001100110001',
    '0111001100110011',
    '0111001100110111',
    '0111011100000000',
    '0111011100001110',
    '0111011100010000',
    '0111011100010001',
    '0111011100110000',
    '0111011100110001',
    '0111011100110011',
    '0111011101220122',
    '0111011111221222',
    '0111012201220122',
    '0111012201221122',
    '0111111111221222',
    '0111111111222222',
    '0111111112222222',
    '0111111122222222',
    '0111111211221122',
    '0111111211221222',
    '0111112212222222',
    '0112001100000000',
    '0112001100010000',
    '0112001100010001',
    '0112001100110001',
    '0112001200110001',
    '0112011100110000',
    '0112011100110011',
    '0112011200110000',
    '0112012201220122',
    '0112111211221122',
    '0112112211221122',
    '0112112212221222',
    '0112112212222222',
    '0122011100110011',
    '0122011200110001',
    '0122011200110011',
    '0122011200120011',
    '0122012201220122',
    '0122012201221122',
    '0122012211221122',
    '0122012211221222',
    '0122112211221111',
    '0122112211221122',
    '0122112212221222',
    '1000000011101110',
    '1000100010110011',
    '1000100011001100',
    '1000100011001110',
    '1000100011001111',
    '1000100011002100',
    '1000100011002110',
    '1000100011002111',
    '1000100011011111',
    '1000100011101110',
    '1000100011101111',
    '1000100011102110',
    '1000100011111111',
    '1000100011112222',
    '1000110011000000',
    '1000110011001000',
    '1000110011001100',
    '1000110011001110',
    '1000110011001111',
    '1000110011002110',
    '1000110011101110',
    '1000110011101111',
    '1000110011102110',
    '1000110011102111',
    '1000110011102211',
    '1000110011111111',
    '1000110021002100',
    '1000110021002110',
    '1000110021102110',
    '1000110021102111',
    '1000110021102210',
    '1000110021102211',
    '1000110021112111',
    '1000110111111111',
    '1000111022112221',
    '1000111122112211',
    '1000111122222222',
    '1001110111011111',
    '1011000000000000',
    '1011000100000000',
    '1011001100010000',
    '1011101111111111',
    '1100000000000000',
    '1100000000000001',
    '1100000000000011',
    '1100000000001100',
    '1100000011111111',
    '1100100000000000',
    '1100100000001000',
    '1100100010000000',
    '1100100010001000',
    '1100100010001100',
    '1100100011001100',
    '1100100011001110',
    '1100100011001111',
    '1100110000000000',
    '1100110000001111',
    '1100110010000000',
    '1100110010001000',
    '1100110010001100',
    '1100110011000000',
    '1100110011001000',
    '1100110011001100',
    '1100110011001101',
    '1100110011001110',
    '1100110011001111',
    '1100110011002100',
    '1100110011010001',
    '1100110011101110',
    '1100110011101111',
    '1100110011102210',
    '1100110011102211',
    '1100110011110111',
    '1100110011111111',
    '1100110011111222',
    '1100110011112111',
    '1100110021002100',
    '1100110021002110',
    '1100110021102110',
    '1100110021102211',
    '1100111022102211',
    '1100111022112211',
    '1100111022112221',
    '1100111112221222',
    '1100111122112211',
    '1100111122112222',
    '1100111122212221',
    '1100111122212222',
    '1100111122222222',
    '1100210021002100',
    '1100210021002110',
    '1100210021002111',
    '1100210021102111',
    '1100210021102210',
    '1100211022102210',
    '1100211022102211',
    '1100211022112211',
    '1100211022112221',
    '1100211122112221',
    '1101000100000000',
    '1101100000000000',
    '1101100010000000',
    '1101110111111111',
    '1110000000000000',
    '1110000000000001',
    '1110000000001110',
    '1110000001110111',
    '1110100000000000',
    '1110100010000000',
    '1110100010001000',
    '1110110000000000',
    '1110110010000000',
    '1110110010001000',
    '1110110010001100',
    '1110110011000000',
    '1110110011001000',
    '1110110011001100',
    '1110110011001110',
    '1110110011101110',
    '1110110011101111',
    '1110111000000000',
    '1110111000000111',
    '1110111010000000',
    '1110111010001000',
    '1110111011000000',
    '1110111011001000',
    '1110111011001100',
    '1110111011001110',
    '1110111022112221',
    '1110111100110011',
    '1110111111221122',
    '1110111122112221',
    '1110111122212221',
    '1110111122212222',
    '1110111122222222',
    '1110211021002100',
    '1110211022112211',
    '1110211122112211',
    '1110211122112221',
    '1110211122212221',
    '1110211122212222',
    '1110221022102211',
    '1110221022112221',
    '1110221122212221',
    '1110221122212222',
    '1111000000000000',
    '1111000000001111',
    '1111000000110011',
    '1111000010001000',
    '1111000011001100',
    '1111000100000000',
    '1111000100010000',
    '1111000100010001',
    '1111001100000000',
    '1111001100010000',
    '1111001100010001',
    '1111001100110000',
    '1111001100110001',
    '1111001100110011',
    '1111011000000000',
    '1111011100000000',
    '1111011100010000',
    '1111011100010001',
    '1111011100110000',
    '1111011100110001',
    '1111011100110011',
    '1111100000000000',
    '1111100010000000',
    '1111100010001000',
    '1111100100000000',
    '1111101100000000',
    '1111101100010000',
    '1111101100110001',
    '1111110000000000',
    '1111110010000000',
    '1111110010001000',
    '1111110011000000',
    '1111110011001000',
    '1111110011001100',
    '1111110021002100',
    '1111110100010000',
    '1111110110000000',
    '1111110110001000',
    '1111111000000000',
    '1111111010000000',
    '1111111010001000',
    '1111111011000000',
    '1111111011001000',
    '1111111011001100',
    '1111111011001110',
    '1111111022102210',
    '1111111100000000',
    '1111111100000011',
    '1111111100001000',
    '1111111100001100',
    '1111111100010000',
    '1111111100010001',
    '1111111100110000',
    '1111111100110001',
    '1111111100110011',
    '1111111110000000',
    '1111111110001000',
    '1111111110010000',
    '1111111110110000',
    '1111111110110001',
    '1111111110110011',
    '1111111111000000',
    '1111111111001000',
    '1111111111001100',
    '1111111111002100',
    '1111111111010001',
    '1111111111011000',
    '1111111111111111',
    '1111111122112210',
    '1111221122102210',
    '1112001100000000',
    '1112011100010000',
    '1112011200110001',
    '1112011200120011',
    '1112111100000000',
    '1112111100110001',
    '1122011100000000',
    '1122011100010000',
    '1122011200110000',
    '1122011200110001',
    '1122011200120011',
    '1122011201110011',
    '1122012201110011',
    '1122012201120011',
    '1122012201120012',
    '1122111100000000',
    '1122111100110000',
    '1122111101110011',
    '1122111101110111',
    '1122111111110000',
    '1122111111110001',
    '1122111111110011',
    '1122111111110111',
    '1122111111111110',
    '1122111201110001',
    '1122111211110111',
    '1122112201110001',
    '1122112201120011',
    '1122112201220112',
    '1122112211110000',
    '1122112211120111',
    '1122112211220111',
    '1122112211220112',
    '1122112211220122',
    '1222111100000000',
    '1222111101110000',
    '1222111101110111',
    '1222111111110000',
    '1222111111111100',
    '1222111200110000',
    '1222111211110011',
    '1222111211110111',
    '1222112201110000',
    '1222112201120012',
    '1222112201120111',
    '1222112201220111',
    '1222112201220112',
    '1222112211110011',
    '1222112211110111',
    '1222122211110000',
    '1222122211110111',
    '1222122211120011',
    '1222122211220111',
    '1222122211220112',
    '1222122211220122',
    '2100110010000000',
    '2100110010001000',
    '2100110011000000',
    '2100110011001100',
    '2100210011001000',
    '2100210011001100',
    '2100210021001100',
    '2100210021002100',
    '2100210021002110',
    '2100210021102110',
    '2100210021102210',
    '2100210021112211',
    '2100211022102210',
    '2100211022102211',
    '2100211122112211',
    '2110110010000000',
    '2110110010001000',
    '2110111011001100',
    '2110210011001000',
    '2110210021002100',
    '2110211011001000',
    '2110211022102210',
    '2110211022102211',
    '2110211122112211',
    '2110221022102210',
    '2110221022102211',
    '2110221022112211',
    '2110221122112211',
    '2110221122212221',
    '2110221122212222',
    '2111110000000000',
    '2111111011001000',
    '2111111111001000',
    '2111111111011000',
    '2111211111000000',
    '2210111011100000',
    '2210111011101110',
    '2210211011001000',
    '2210211021001100',
    '2210211021002100',
    '2210221011101110',
    '2210221021101100',
    '2210221022101110',
    '2210221022102110',
    '2210221022102210',
    '2210221022102211',
    '2210221022112211',
    '2210221022112221',
    '2210221122112211',
    '2210221122112221',
    '2210221122212221',
    '2211111010000000',
    '2211111100110000',
    '2211111111101100',
    '2211111111101110',
    '2211111111110000',
    '2211111111111000',
    '2211111111111110',
    '2211211011001000',
    '2211211021001100',
    '2211211021002100',
    '2211211111101100',
    '2211211111101110',
    '2211211111111100',
    '2211211111111110',
    '2211211121102110',
    '2211221021102100',
    '2211221022102210',
    '2211221111101000',
    '2211221111111110',
    '2211221121102100',
    '2211221121111110',
    '2211221121112110',
    '2211221122111110',
    '2211221122112110',
    '2221111100010000',
    '2221111101110111',
    '2221111111000000',
    '2221111111110000',
    '2221111111111000',
    '2221111111111100',
    '2221111111111110',
    '2221211111110111',
    '2221221111111110',
    '2221221121101100',
    '2221221121102100',
    '2221221122102110',
    '2221221122102210',
    '2221222111110111',
    '2221222111111100',
    '2221222122111110',
    '2221222122112110',
    '2221222122112210',
    '2222111100000000',
    '2222111100010001',
    '2222111100110011',
    '2222111101110111',
    '2222111111101000',
    '2222111111110000',
    '2222111111110111',
    '2222111111111000',
    '2222111111111011',
    '2222111111111100',
    '2222111111111110',
    '2222112201110000',
    '2222112211110111',
    '2222122211110000',
    '2222122211110111',
    '2222122211220122',
    '2222211111111101',
    '2222221111110011',
    '2222221121111110',
    '2222222111110001',
    '2222222122112110',
    '2222222122112210',
    '2222222211110000',
    '2222222211110001',
    '2222222211110011',
    '2222222211110111',
    '2222222211111110',
    '2222222211220111',
];
//# sourceMappingURL=cliff-windows.generated.js.map